// Note: this doesn't check for conflicts between module exports
export { renderHTML } from "./render-html"
